
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`እዚ ብ
                    <a href="${0}">ፕሮጀክት ፎልክሶኖሚ ሞተር</a>ዝመጸ እዩ።
                    ክትሳተፉ ወይ ርእይቶ ክትህቡ ድሕር ኣይትበሉ`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`እዚ መሳርሒ እዚ ነቲ ዝርዝር ቀመማት ከተዐርዮ የኽእለካ።
                ዝርዝር ቀመማት ክትውስኽ፣ ከተውጽእ ወይ ከተዐርዮ ትኽእል ኢኻ።
                <br>
                እዚ ፊደል <span class="highlight">␣</span> ንሓደ ቦታ ዝውክል እዩ።
                <br>
                እዚ ፊደል <span class="highlight">↩︎</span> ንሓደ መስመር ምብታኽ ይውክል። `,
'hb28f1f2ec1744ee9': html`እዞም ንብረታት እዚኦም ብዝኾነ ዓይነት ኣጠቓቕማ ብተጠቀምቲ ዝፍጠሩን ዝቐርቡን እዮም።
                    ናጻ ኮይኑ ናትኩም ክትውስኹ ትኽእሉ ኢኹም። እቶም እትፈጥሮም ባህርያትን ክብርታትን
                    <strong>ጭቡጥ</strong>ክኾኑ ኣለዎም። ኣብ
                    <a href="${0}">ዝርዝር ናይቶም ድሮ ሕብረተሰብ ዝጥቀመሎም ንብረታት</a>
                    ክትጥሕል ወይ ድማ
                    <a href="${1}">ንብረት ሰነዳትን ሞተር ምድላይኡን</a>ክትድህስስ ትኽእል።`,
's000a5b76bd3a01c2': `ንብረት ምጽዓን...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `ንቐመማት ሓግዙና።`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ዝራእቲ ምጽዳቕ`,
's03e9c8114521b998': `ቀመማት ክእርሞ እየ`,
's05ec315d9308091a': `ባርኮድ ኩርናዓት ምልክት`,
's061eb5af92512c85': `ድሒኑ! ኣብ ካልእ ክትሕግዝ ትኽእል ዲኻ?`,
's06847c221c4c0bc1': `[ኣጠቓቕማኻ ንምግላጽ] ንብረት ክፈጥር እደሊ...`,
's06f6c6f99db6b552': `ኦርጂናል`,
's081e2ad82db71e1d': `ዝተጠርነፉ ክብርታት`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `ውፉይ ሰነዳት።`,
's0bb2d48532acc455': `CSV ኣውርድ`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `ምስሊ ትኽክል ምግባር`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `ዝራእቲ ምስራዝ`,
's11a18a69b30b65ed': `ኣብ ዝርዝር ቀመማት ጌጋታት ንምእራም ሓግዙና።`,
's1205d5f6fccf8e69': `ዋጋ ንብረት`,
's15d64a0a6715285a': `ሓድሽ መፍትሕ`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `ናይ ምምራጽ ቦታ`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ነቲ ናይ ኣመጋግባ ሓበሬታ ንምእራም ሓግዙና።`,
's1e00019dc454872d': `በጃኻ ንብረት-ስም ባህሪ ተጠቒምካ ስም ንብረት ኣቕርብ።`,
's1e49126af0935a5b': `ነዚ ንብረት ዝጥቀሙ ፍርያት ዝርዝር`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ነቲ ንብረት ሰነድ`,
's300b3a6ee4e1252d': str`ድኹም ምትእስሳር ${0}%`,
's33f786bb6b4f0cf4': `ውጽኢት ዝራእቲ`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `መጀመርያ ንማሕበረሰብ ሕተትዎ።`,
's36d86adc823cbfa6': `ቅድሚ ሓድሽ ንብረት ምፍጣርካ ምስ ሕብረተሰብ ምዝርራብ፤`,
's3781d25aa51a736c': `ፎልክሶኖሚ ሞተር ሰነድ`,
's383ae4449428b61e': `ዝራእቲ ዳግማይ ምትካል`,
's39bcf88721a1e8ee': `ምርጫ ዳግማይ ምትካል`,
's39e14e14300694c7': `ሰነዳትን መምርሕታትን`,
's3b430cfa5c1fe7f4': str`ን ${0}ዝኸውን ሰነድ`,
's3f4e4b52f230a892': `ምስሊ ካንቫስ`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `ማእከል ምስሊ`,
's42dd66b2441566fd': `ማእከል ምልክት`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `ስፍሓት ብትኽክል ምቕያር`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `ቁጽሪ ፍርያት`,
's4df2f533c0c1e7d0': `ናይ ምስሊ ቁጽጽር`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `ምምራጽ ምንቅስቓስ`,
's4f751fb9b3ed766c': `ሓድሽ ንብረት ምፍጣር`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `ስም ንብረት ኣእትዉ...`,
's55d7249883a98ca1': `ብዛዕባ እዚ ንብረት ኣብ Open Food Facts wiki`,
's565867d84c04aea2': `ናይ ፍልተር ባህርያት...`,
's5666afe5cd0166de': `በጃኻ ቅድሚ ምርግጋጽካ ነቲ ጌጋታት ኣዐርዮ ወይ ነቲ ጽሑፍ ኣዐርዮ`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `ፍርያት ኣብ ምጽዓን...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ነቲ ናይ ኣመጋግባ ሓበሬታ ንምእራም ሓግዙና።`,
's5dd6f12783fca34f': `ዝርዝር ቀመማት ኣርትዕ`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `ዝተቖርጸ ምስሊ`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ጽቡቕ ምትእስሳር ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ሰነድ ምግባር`,
's787dd11bed0dc88a': `ስፍሓት ንጸጋም ምቕያር`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `ብዛዕባ ምፍጣር ንብረትን መምርሕታትን ዝያዳ ፍለጡ፤`,
's8038273de2cf8b73': `በጃኹም ክትዘርእዎ ዘለኩም ዞባ ምረጹ።`,
's839cc2908a5387f2': `ባርኮድ ምፍታሕ...`,
's86197dcf3e96af64': `ንዝጸንሑ ንብረታት ምድህሳስን ምድላይን።`,
's8a63be30a129a59c': `ታሕተዋይ ስፍሓት ምቕያር`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ኣብ ላዕሊ የማን ዓቐን ምቕያር`,
's8db84aa4bc949af2': `ነቲ ሓድሽ ንብረት ሰነድ`,
's8f839a03997a16d7': `ፍርያት ርአ`,
's901ae1e236ac45d3': `ምድምሳስ ስርዝ ድልዝ`,
's907f7a97c6b29425': `እቲ ዳታ ሞዴል ክቕየር ከም ዝኽእል ኣስተውዕል። ብናይ ገዛእ ርእስኻ ሓደጋ ተጠቐመሉ።`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ንጥረ ነገራት ፥`,
's9a7f60fce090ecaf': `ንብረት ምጽዓን ኣይከኣለን። በጃኹም ድሒርኩም ደጊምኩም ፈትኑ።`,
's9b87abd68fb9df45': `ኣይተረኽበን? ሓድሽ መፍትሕ {value}ምፍጣር`,
's9c0f52425fd2f07e': `ምናልባት ኣይክሰማማዕ ይኽእል እዩ።`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `ነጥቢ የለን`,
'sa548778b24054030': `ኩሎም ካብ ፕሮጀክት ፎልክሶኖሚ ሞተር ዝተበርከቱ ንብረታት ዳህሰሱ። እዞም ባህርያት እዚኦም ተወሳኺ ሜታዳታን ርድኢትን ብዛዕባ ፍርያት ኣብ ዳታቤዝ ክፉት ሓቅታት መግቢ ይህቡ።`,
'sa63907958bd0ec4b': `ኣብ ላዕሊ ጸጋም ዓቐን ምቕያር`,
'sa95b4224f685a36a': `ሞዳል ዕጸዎ።`,
'sab56a1d439576fd6': `ናይ ሓሳብ ምልክት`,
'sac47ea2901d04c15': `ኣብ ታሕቲ ጸጋም ዓቐን ምቕያር`,
'sb125227d436c2925': `ኣብቲ ዝጸንሐ ናይ ንብረት ዳታቤዝ ንብረትካ ኣምር ድለዮ፤`,
'sb125568d43642e6f': `ብዛዕባ እቲ ፍርያት ዝምልከት ሕቶታት መልሱ።`,
'sb1c538e038f9b214': str`ብጣዕሚ ጽቡቕ ምትእስሳር ${0}%`,
'sb28639570ff3b852': `ዝርዝር ናይ ኩሎም ንብረታት`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `ንብረትካ ከምዘየለ ምስ ኣረጋገጽካን እቲ ማሕበረሰብ ጠቓሚ ምዃኑ ምስ ተሰማምዐን፡ መጀመርታ ኣብቲ ዊኪ ክትስነዶ ኣለካ።`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ነዚ ንብረት ዝኸውን ፍርያት ኣይተረኽበን።`,
'sb7f72e4c8a2d3357': `ክብርታት መጽረዪ...`,
'sb8178320160f84ea': `ዝራእቲ ኣርእዩ`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ኩሉ ርድኢታት መልሲ ረኺቡ እዩ! ንዝገበርኩምልና ሓገዝ የቐንየልና!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `ተዛማዲ ዋጋ`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `ላዕለዋይ ደረጃ ምቕያር`,
'sc1c08d0cbcc3bd24': `ኣይሰማማዕን እዩ።`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `ሓሳብ ምእራም`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `ምስሊ ምንቅስቓስ`,
'sc895972c88d38ca5': `ንብረት ፎልክሶኖሚ`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `መስርዕ`,
'scb3b0671d7b7f640': `ሓድሽ ዋጋ`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `ኣብ ስላክ ዘተ ተጸንበሩ`,
'scdb6cad0b92721bf': `ንብረት ኣይተረኽበን።`,
'scf23a05631f93732': `ምድምሳስ ኣረጋግጽ`,
'scfed2f270ef6a3aa': `ከባቢ ምረጽ`,
'sd1022bc1ef9204f7': `ዙም ዝግበረሉ ምስሊ`,
'sd1077c055cf9ba6b': `ዝርዝር ቀመማት ናይቲ ፍርያት ንምርግጋጽ ሓግዙና።`,
'sd698d21ddecba56b': `ሰላም! ነዞም ዝስዕቡ ክፋላት ብምምላስ ሓበሬታ ፍርያት ንምምሕያሽ ክትሕግዙና ትኽእሉ ኢኹም፤`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `ድሮ ሓደ ንብረት እንተሃልዩ ኣረጋግጽ`,
'sdbf806fefc584115': `ክትረክብ ይግባእ ሀ`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `ኣጸሓሕፋ ቀመማት ንምእራም ሓግዙና።`,
'sdca5deead576ceee': `ኣብ ታሕቲ የማን ዓቐን ምቕያር`,
'sdcc2555c5dde524f': `ነዚ ንብረት ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ? እዚ ተግባር እዚ ክምለስ ኣይክእልን እዩ።`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `ውዱቕ ምግባር`,
'se5127cf0f92e7e48': `ምኽሪ፦ ነቲ...`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `ዝሓሸ ዝራእቲ ክህሉ ሓሳብ ከቕርብ እየ`,
'seea3800e27baa686': `ውልቀ ፍርያት`,
'sefaba4adc4ec9219': `ፎልክሶኖሚ ንብረት`,
'seffa8ca49175b5f0': `ብሕታዊ ንብረት`,
'sf44a6b3b232c28ea': str`ናይ ሕጂ ዋጋ ብ ${0}ተክኦ`,
'sf4cd86a2f5ef2588': `ፍርያት ባርኮድ`,
'sf57a61152168cc81': `ነቲ ናይ ቀመማት ምልላይ ንምእራም ሓግዙና።`,
'sf88b90b8ba23871c': `ዘይተፈልጠ ምትእስሳር`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `ስም ንብረት፤`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `ተዛማዲ ዋጋ`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  